const { hostname } = window.location;
const trimmedHostname = hostname.split(".").slice(-2).join(".");
const baseUri = `https://api.${trimmedHostname}`;
const authBase = "/auth/v1";
const authLogin = "/login";

export const authUrl = baseUri + authBase + authLogin;
export const sessionCheckInterval = 5000; // checks every second trigger "significant energy" warnings in Safari
export const warningMinToExp = 5;
